export default __webpack_public_path__ + "static/media/IQVIA-footer.6de2fa01.svg";